module.exports = __webpack_public_path__ + "img/4-l.9439f168.png";